import * as React from 'react';

function EmptyValuations() {
  return (
    <div className="py-4 border-bottom">
      <p className="clearfix">
       <p><strong>Preset Valuations</strong></p>
        <div >
          You have no preset stock valuations saved yet.
        </div>
      </p>
    </div>
  );
}

export default EmptyValuations;
